<script>
    import { onMount } from 'svelte';
    import * as d3 from 'd3';
    import { BASE_DATA_URL } from '../constants';
    import { buildCacheParam } from '../utils';
    import irelandVaccinationsChart from '../charts/irelandVaccinationsChart';

    let chartContainer;

    onMount(async () => {
        const data = await d3.csv(`${BASE_DATA_URL}/ireland-vaccinations.csv?d=${buildCacheParam()}`);
        const chart = irelandVaccinationsChart().data(data);
        d3.select(chartContainer).call(chart);
    });
</script>

<div class="chart-outer">
    <h3>How are vaccinations going in Ireland?</h3>
    <div bind:this={chartContainer}/>
</div>
